import { __extends } from "tslib";
import { EventBase } from '@awayjs/core';
var TextureProjectorEvent = /** @class */ (function (_super) {
    __extends(TextureProjectorEvent, _super);
    function TextureProjectorEvent(type) {
        return _super.call(this, type) || this;
    }
    //@override
    TextureProjectorEvent.prototype.clone = function () {
        return new TextureProjectorEvent(this.type);
    };
    TextureProjectorEvent.TEXTURE_CHANGE = 'textureChange';
    return TextureProjectorEvent;
}(EventBase));
export { TextureProjectorEvent };
